export default "__VITE_ASSET__225c24f1__"